import { Modal, Typography } from '@ag1/ui';

import { useTranslation } from 'react-i18next';
import styles from './SiteCartHeader.module.scss';

export const SiteCartHeader = () => {
  const { t } = useTranslation('siteCart');

  return (
    <Modal.Header className={styles.container}>
      <Typography variant="body" size="1" weight="700" noPadding className={styles.title}>
        {t('title')}
      </Typography>
    </Modal.Header>
  );
};
